(function ($) {
    
    function arrowClicks(){
        $('.nav-menu li .arrow').on('click',function(e) {
            e.preventDefault();
            $( this ).next().addClass('active');
//            $( this ).parents('.menu-item').css('position','static');
            $( this ).closest('.menu-item').addClass('static');
        });
        $('.sidr__menu-back').on('click',function(){
            var menuCloseId = $( this ).data('sidr-menu');
//            var menuId = menuCloseId.substring(5, menuCloseId.length);
            
            $( '#' + menuCloseId ).removeClass('active');
//            $( this ).parents('.menu-item').css('position','relative');
            $( this ).closest('.menu-item').removeClass('static');
        });
    }

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: false,
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'));

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });
        
        $('#sitesearch--toggle').on('click',function(e) {
            $("html, body").animate({ scrollTop: 0 }, "fast");
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
            $('#sitesearch').toggleClass('active');
        });
        $('#sitesearch--close').on('click',function(e) {
            $('#sitesearch').removeClass('active').unbind();
        });

        
        //Sidr
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu"><div class="sidr__inner">';
                
                sidrHtml += '<div class="sidr__mainnav">' + $('.main-navigation').html() + '</div>';
                
                if($('.sub-navigation').length){
                    sidrHtml += '<div class="sidr__subnav">' + $('.sub-navigation').html() + '</div>';
                }
                
                sidrHtml += '</div></div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                var headerHeight = $("#masthead").height();
                
                $('#sitesearch').removeClass('active').unbind();
                
                $( '.sidr' ).css('margin-top',headerHeight);
                
                $('#mobile-trigger').addClass('active');
                
                $( 'body' ).prepend( '<div class="sidr-overlay" style="height: calc(100% - ' + headerHeight + 'px); top: ' + headerHeight + 'px;"></div>' );
                
//                $('.sidr__inner').find('.sub-menu').not(".sub-menu .sub-menu").each(function() {
                $('.sidr__inner').find('.sub-menu').each(function() {
                    var menuId = $(this).parents('.menu-item').attr('id'),
                        parentLink = $(this).prevAll('a').attr('href'),
                        parentText = $(this).prevAll('a').html();
                    
                    $(this).attr('id','sidr-' + menuId).prepend('<li class="sidr__menu-back" data-sidr-menu="sidr-' + menuId + '">' + parentText + '</li>');
                });
            },
            onOpenEnd: function(){
                arrowClicks();
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
                $('#mobile-trigger').removeClass('active');
            },
            onCloseEnd: function(){
                $('.sidr__inner').find('.sub-menu').each(function() {
                    $(this).find('.sidr__menu-back').remove();
                });
            }
        });

        $('.sidr__close').click(function() {
            $('#sitesearch').removeClass('active').unbind();
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
        });
        
        
            
        $( '.js-video-popup' ).magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });

	});
    
})(jQuery);